export default {
  NOTIFICATIONS_SELECT: '@NOTIFICATIONS_SELECT',
  NOTIFICATIONS_APPLY_FILTER: '@NOTIFICATIONS_APPLY_FILTER',
  NOTIFICATIONS_UNSELECT_ALL: '@NOTIFICATIONS_UNSELECT_ALL',
};
